import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ShippingPolicy = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        fill="none"
        viewBox="0 0 32 32"
        ref={forwardedRef}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.4307 28.5625L5.06818 22.5V7.78556L16.4307 3L27.1932 7.78556V22.5L16.4307 28.5625Z"
          fill="#F8B200"
        />
        <path
          d="M5.06818 7.78556L16.4307 12.875M5.06818 7.78556V22.5L16.4307 28.5625M5.06818 7.78556L16.4307 3L27.1932 7.78556M16.4307 12.875V28.5625M16.4307 12.875L27.1932 7.78556M16.4307 28.5625L27.1932 22.5V7.78556"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.47443 19.25V9.4375L19.6932 4.5L23.8807 6.1875L12.9432 11.5V21.5625L8.47443 19.25Z"
          fill="#99E538"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.56818 9.75L13.1307 11.625"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1932 21.6875V14.75L23.1932 12.875V19.625L19.1932 21.6875Z"
          fill="white"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default ShippingPolicy
